export default __webpack_public_path__ + "static/media/fast_track2.7fe0ab7a.svg";